module.exports = __webpack_public_path__ + "static/title.71bfd931.png";